export const isBookingPhoneNumberInvalid = (phoneNumber: string) =>
  phoneNumber.startsWith('0') || phoneNumber.startsWith('1');
